<template>
  <section class="form__content">
    <h3>1. {{ $t('datesOfStay.title') }}</h3>

    <!-- Arrival -->
    <v-menu ref="menu"
            v-model="menu.arrival"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-form v-model="arrivalValid">
          <v-text-field :value="arrivalDateHuman"
                        :label="$t('datesOfStay.arrivalDateLabel')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[arrivalErrorRequiredValidation, arrivalDepartureDifferenceValidation]"
          />
        </v-form>
      </template>
      <v-date-picker :value="arrivalDate"
                     @input="$emit('update:arrival-date', $event)"
                     no-title
                     scrollable
      />
    </v-menu>

    <!-- Departure -->
    <v-menu ref="menu"
            v-model="menu.departure"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-form v-model="departureValid">
          <v-text-field :value="departureDateHuman"
                        :label="$t('datesOfStay.departureDateLabel')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[departureErrorRequiredValidation, arrivalDepartureDifferenceValidation]"
          />
        </v-form>
      </template>
      <v-date-picker :value="departureDate"
                     @input="$emit('update:departure-date', $event)"
                     no-title
                     scrollable
      />
    </v-menu>
  </section>
</template>

<script>
export default {
  name: 'DatesOfStay',

  props: {
    valid: {
      required: true,
    },
    arrivalDate: {
      required: true,
    },
    departureDate: {
      required: true,
    },
  },

  data: () => ({
    arrivalValid: false,
    departureValid: false,
    menu: {
      arrival: false,
      dateOptions: { day: 'long', month: 'long', year: 'numeric' },
      departure: false,
    },
    arrivalErrorMessage: '',
    departureErrorMessage: '',
  }),

  computed: {
    arrivalDateHuman () {
      return this.arrivalDate
             ? (new Date(this.arrivalDate)).toLocaleDateString(navigator.language, this.dateOptions)
             : ''
    },
    arrivalErrorRequiredValidation () {
      return !!this.arrivalDate || this.$t('error.required')
    },
    arrivalDepartureDifferenceValidation () {
      if (!this.arrivalDate || !this.departureDate) return true

      const arrival = (new Date(this.arrivalDate)).getTime()
      const departure = (new Date(this.departureDate)).getTime()

      return arrival < departure || this.$t('error.arrivalDeparture')
    },
    departureErrorRequiredValidation () {
      return !!this.departureDate || this.$t('error.required')
    },
    departureDateHuman () {
      return this.departureDate
             ? (new Date(this.departureDate)).toLocaleDateString(navigator.language, this.dateOptions)
             : ''
    },
  },

  watch: {
    arrivalValid() {
      this.$emit('update:valid', this.arrivalValid && this.departureValid)
    },
    departureValid() {
      this.$emit('update:valid', this.arrivalValid && this.departureValid)
    }
  }
}
</script>
